import {
  GET_MERIT_API_LOG_DETAILS_SUCCESS,
  GET_MERIT_API_LOGS_SUCCESS,
  GET_MERIT_ORDER_DETAILS_SUCCESS,
  GET_MERIT_ORDERS_SUCCESS,
  MERIT_LOADING,
} from "./Action";

const getListFromPayload = (payload, keys) => {
  for (const key of keys) {
    if (Array.isArray(payload?.data?.[key])) {
      return payload.data[key];
    }
  }

  if (Array.isArray(payload?.data?.data)) {
    return payload.data.data;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

const getTotalCount = (payload) =>
  payload?.extra?.total_count ??
  payload?.meta?.total_count ??
  payload?.meta?.total ??
  payload?.total ??
  0;

const initialState = {
  orders: [],
  ordersCount: 0,
  orderDetails: {},
  apiLogs: [],
  apiLogsCount: 0,
  apiLogDetails: {},
  load: null,
  error: null,
};

const meritReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case MERIT_LOADING:
      return {
        ...state,
        load: payload,
      };
    case GET_MERIT_ORDERS_SUCCESS:
      return {
        ...state,
        orders: getListFromPayload(payload, [
          "merit_orders",
          "orders",
          "merit_gift_orders",
        ]),
        ordersCount: getTotalCount(payload),
      };
    case GET_MERIT_ORDER_DETAILS_SUCCESS: {
      const details =
        payload?.data?.merit_order ??
        payload?.data?.order ??
        payload?.data ??
        payload;

      return {
        ...state,
        orderDetails: details,
      };
    }
    case GET_MERIT_API_LOGS_SUCCESS:
      return {
        ...state,
        apiLogs: getListFromPayload(payload, [
          "api_logs",
          "merit_api_logs",
          "logs",
        ]),
        apiLogsCount: getTotalCount(payload),
      };
    case GET_MERIT_API_LOG_DETAILS_SUCCESS: {
      const details =
        payload?.data?.api_log ??
        payload?.data?.merit_api_log ??
        payload?.data ??
        payload;

      return {
        ...state,
        apiLogDetails: details,
      };
    }
    default:
      return state;
  }
};

export default meritReducer;
